import React, {useContext} from 'react'
import NavbarStore from "./store/NavbarStore";
import TopBarRightSection from "./Components/TopBarRightSection";
import {observer} from "mobx-react";
import {AuthContext} from "../../../context/AuthContext";
import {roleIdToString} from "../../../utils/roleIdToString";

const NavBarTemplate = observer(
    (props) => {
        const {logout, userName, roleId} = useContext(AuthContext)
        return (
            <>
                <div id={'deff'}
                     style={NavbarStore.navBarShow ? {display: 'flex'} : {display: 'none'}}
                     className={`top-bar ${NavbarStore.mobile ? 'mobile scale-up-hor-left' : ''}`}>

                    <div className="name">
                        {userName &&
                        <>
                            <span style={{fontWeight: 'bold'}}>
                                {roleIdToString(roleId)}
                            </span>
                            {userName}
                        </>}
                    </div>

                    <div
                        className="routes">
                        {props.routeList}
                        <div onClick={logout} className="top-bar__option top-bar__option_logout">
                            <a href="/">Выйти</a>
                        </div>
                    </div>
                    <TopBarRightSection/>
                    <div
                        className="close"
                        onClick={() => {NavbarStore.setShowInMobile(!NavbarStore.navBarShow)}}>

                        <i className="fas fa-times"/>
                    </div>
                </div>
            </>
        )
    }
)
export default NavBarTemplate 